import React, { useEffect } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { blogAddEdit } from "../../../../services/BlogService";
import DatePicker from "../../../form/DatePicker";
import TimePicker from "../../../form/timePicker/TimePicker";
import FileUploadSingle from "../../../form/FileUploadSingle";

const validation = {
  title: { required: true, message: "Event title is required" },
  publishDate: { required: true, message: "Publish date title is required" },
};

const ManageCalender = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        image: data?.image?.url,
        ...data?.location,
        time: {
          startTime: data?.startTime,
          endTime: data?.endTime,
          timezone: data?.timezone,
        },
      });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        ...val?.time,
        location: { label: val?.label, url: val?.url },
      };
      delete payload?.time;
      delete payload?.label;
      delete payload?.url;
      delete payload?._id;
      return await blogAddEdit({
        ...payload,
        type: "event",
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-12">
          <Input
            label="Event Title"
            inputPlaceholder={"Enter  Event Title"}
            inputName="title"
            value={values?.title || ""}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <Input
            label={"Location or URL Title"}
            inputPlaceholder={"Enter title"}
            inputName="label"
            value={values?.label || ""}
            onChange={handleChange}
            {...formValidate(errors, "label")}
          />
        </div>
        <div className="relative col-span-4">
          <Input
            label={"Location or URL"}
            inputPlaceholder={"URL"}
            inputName="url"
            value={values?.url || ""}
            onChange={handleChange}
            {...formValidate(errors, "url")}
          />
        </div>
        <div className="relative col-span-4">
          <FileUploadSingle
            size="small"
            label={"Upload Cover Image"}
            value={values?.image}
            onChange={(file) =>
              handleChange({ target: { name: "image", value: file } })
            }
            {...formValidate(errors, "image")}
          />
        </div>
        <div className="relative col-span-3">
          <DatePicker
            className={"placeholder:text-[10px]"}
            label={"Start Date"}
            placeholder={"Enter Start Date"}
            value={{
              startDate: values?.publishDate,
              endDate: values?.publishDate,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "publishDate" },
              });
            }}
            {...formValidate(errors, "publishDate")}
          />
        </div>
        <div className="relative col-span-3">
          <DatePicker
            className={"placeholder:text-[10px]"}
            label={"End Date"}
            placeholder={"Enter End Date"}
            value={{
              startDate: values?.publishEndDate,
              endDate: values?.publishEndDate,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "publishEndDate" },
              });
            }}
            {...formValidate(errors, "publishEndDate")}
          />
        </div>
        <div className="relative col-span-3">
          <DatePicker
            className={"placeholder:text-[10px]"}
            label={"Display Date"}
            placeholder={"Select Display Date"}
            value={{
              startDate: values?.displayDate,
              endDate: values?.displayDate,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "displayDate" },
              });
            }}
            {...formValidate(errors, "displayDate")}
          />
        </div>
        <div className="relative col-span-3">
          <DatePicker
            label={"Unavailable Date"}
            className={"placeholder:text-[10px]"}
            placeholder={"Select Unavailable Date"}
            value={{
              startDate: values?.unavailableDate,
              endDate: values?.unavailableDate,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "unavailableDate" },
              });
            }}
            {...formValidate(errors, "unavailableDate")}
          />
        </div>
        <div className="relative col-span-6">
          <Select
            label={"Event Type"}
            placeholder="Enter Event Type"
            selectedValue={values?.eventType}
            dropdownData={[
              { name: "Online (Virtual)", value: "Online" },
              { name: "In-Person", value: "Offline" },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "eventType", value: val },
              });
            }}
          />
        </div>
        <div className="relative col-span-6">
          <Select
            label={"Status"}
            placeholder="Select status"
            selectedValue={values?.status}
            dropdownData={[
              { name: "Published", value: 1 },
              { name: "Draft", value: 2 },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "status", value: val },
              });
            }}
          />
        </div>
        <div className="relative col-span-12">
          <Editor
            label="Description"
            placeholder="Description"
            value={values?.description}
            onChange={(val) =>
              handleChange({
                target: { name: "description", value: val },
              })
            }
            {...formValidate(errors, "description")}
          />
        </div>
        <div className="relative col-span-8">
          <TimePicker
            label={"Start Time & End Time"}
            placeholder={"Select Start & End Time"}
            second={false}
            value={values?.time}
            range
            onChange={(val, date) => {
              handleChange({
                target: { value: val, name: "time" },
              });
            }}
            {...formValidate(errors, "time")}
          />
        </div>
        <div className="relative col-span-4">
          <Input
            label="Contact email"
            inputPlaceholder={"Enter Contact email"}
            inputName="email"
            inputType={"email"}
            value={values?.email || ""}
            onChange={handleChange}
            {...formValidate(errors, "email")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <div className="relative">
            <Button
              buttonType="submit"
              buttonLabel={"Save Event"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              {...(isLoading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
          </div>
          <div className="relative">
            <Button
              buttonLabel={"Cancel"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              buttonFunction={close}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default ManageCalender;
